export default __webpack_public_path__ + "static/screenshot_6d-327412852f26ac16c6fffc9291f9ec58.png";